import React from 'react'
import styles from './FilterToggle.module.scss'

interface FilterToggleProps {
  label: string
  active: boolean
  onClick: () => void
  className?: never
}

export const FilterToggle: React.FC<FilterToggleProps> = ({
  label, active, onClick,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={[styles.button, active ? styles.active : styles.inactive].join(' ')}
  >
    {label}
  </button>
)
